import { Post, Get } from "../utils/Api";
import { UnitGroup } from "../types/UnitGroup";

export interface IReservationRequest {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  unitGroupId: string; // if you send this alone any available unit will be reserved for this unitgroup
  unitGroupTierId?: string; // if you send this along with the unitGroupId that particular unit will be reserved
  isReservation: boolean;
  desiredMoveInDate?: string;
  notes?: string;
  source?: string;
  onlineMoveInUrl: string;
  discountPlans?: string[];
  isOnlineMoveInEnabled?: boolean;
  smsConsent?: boolean;
}

export interface IReservationResponse {
  id: string;
  reservationId: string;
  alias: string;
  contactId: string;
  softwareProvider: string;
  facilityId: string;
  companyId: string;
  unitId: string;
  createdAt: string;
  updatedAt: string;
  notes?: string;
  unit: UnitGroup;
  unitGroupId?: string;
}

export const CreateReservation = (
  accessKey: string,
  data: IReservationRequest,
) =>
  Post<IReservationResponse, IReservationRequest>(accessKey, "/v1/leads", data);

export const GetLead = (accessKey: string, leadId: string) =>
  Get<IReservationResponse>(accessKey, `/v1/leads?leadId=${leadId}`);
